export default {
  ONBEHALF: 'ONBEHALF',
  PRIVATE_WEBSITE: 'PRIVATE_WEBSITE',
  PRIVATE_IDF: 'PRIVATE_IDF',
};
